module.exports = __webpack_public_path__ + "stylesheets/info-app-sumo_49becd49a6a3cb7e4d370c3f05200f26.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/settings/info-app-sumo.less
// module id = yQlI
// module chunks = 51